import { render, staticRenderFns } from "./OrganisationSideBar.vue?vue&type=template&id=76d3699b&scoped=true&"
import script from "./OrganisationSideBar.vue?vue&type=script&lang=js&"
export * from "./OrganisationSideBar.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationSideBar.vue?vue&type=style&index=0&id=76d3699b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d3699b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VBtn,VCard,VDivider,VIcon,VList,VListItem,VMenu,VNavigationDrawer})
